import React, { useContext } from 'react'

//
import { ButtonNew, OfficesBlock } from '../../../storybook'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'
import { BUTTON_VARIANT } from '@/src/storybook/ButtonNew/ButtonNew'
import { THEME } from '@/src/utils/common'
import { useNavigationData } from '@/src/context/NavigationContext'

const BlockOffices = ({ data: { title, preface, offices = [], action, theme } }) => {
  const { navigationItems } = useNavigationData()
  const location = useContext(LocationContext)
  const { slugPrefix } = location

  const cards = offices?.map(({ id, title, description: address, image, action: cardAction }) => ({
    id: id,
    title: title || '',
    description: address || '',
    image: image,
    action: cardAction && (
      <ButtonNew
        classes="u-margin-top:24"
        size={'md'}
        variant={BUTTON_VARIANT.GREEN}
        url={getUrl({
          navItem: cardAction,
          slugPrefix: slugPrefix,
          navigationItems: navigationItems
        })}
      >
        {cardAction.title}
      </ButtonNew>
    )
  }))

  const cta = action ? (
    <ButtonNew
      variant={theme === THEME.dark ? BUTTON_VARIANT.SECONDARY : BUTTON_VARIANT.PRIMARY}
      url={getUrl({
        navItem: action,
        slugPrefix: slugPrefix,
        navigationItems: navigationItems
      })}
    >
      {action.title || ''}
    </ButtonNew>
  ) : null

  return (
    <OfficesBlock
      title={title || ''}
      eyebrow={preface || ''}
      actionSlot={cta}
      items={cards}
      theme={theme}
    />
  )
}

export default BlockOffices
